export enum Period {
    TODAY = "TODAY",
    LAST_DAY = "LAST_DAY",
    LAST_WEEK = "LAST_WEEK",
    LAST_MONTH = "LAST_MONTH",
    LAST_QUARTER = "LAST_QUARTER",
    LAST_YEAR = "LAST_YEAR"
}
